import { Colors, FontStyleEnums } from '@oy/uicore';
import { SystemIcon } from '@oy/uiicon';
import classNames from 'classnames';
import React, { FC, useContext } from 'react';
import { formatString, makeId } from '../../../../utilities/idComponent';
import { Text } from '../../../Contents';
import { Padder, PadderProps } from '../../../Layout';
import { ModalContext } from '../ModalContext';
import styles from './ModalHeader.module.css';

export type ModalHeaderProps = {
  children: string | React.ReactNode;
  onBack?: () => void;
  showBackButton?: boolean;
  showCloseButton?: boolean;
  showDivider?: boolean;
  subTitle?: string;
  closeButtonId?: string;
} & PadderProps;

const Header: FC<ModalHeaderProps> = ({
  children,
  className,
  id,
  onBack,
  showBackButton = false,
  showCloseButton = false,
  showDivider = false,
  closeButtonId,
  subTitle,
  ...props
}: ModalHeaderProps) => {
  const { onClose, disableOnClose } = useContext(ModalContext);

  const containerClass = classNames(
    styles.container,
    {
      [styles.divider]: showDivider,
    },
    className,
  );

  const backButtonClass = classNames(styles.button, styles.backButton);
  const closeButtonClass = classNames(styles.button, styles.closeButton);

  return (
    <Padder
      id={makeId('modal', formatString(children), id)}
      horizontal={Padder.Size.M}
      className={containerClass}
      {...props}
    >
      {showBackButton && (
        <button onClick={onBack} className={backButtonClass} type="button">
          <SystemIcon name="back" color={Colors.BLACK100} />
        </button>
      )}
      <div className={styles.innerContainer}>
        <div className={styles.titleSection}>
          <Text
            id="txtModalHeader"
            color={Colors.BLACK100}
            textStyle={FontStyleEnums.BodyXlSemibold}
          >
            {children}
          </Text>
          {subTitle && (
            <Text textStyle={Text.Style.BodyMdRegular} color={Colors.BLACK80}>
              {subTitle}
            </Text>
          )}
        </div>
        {showCloseButton && (
          <button
            onClick={onClose}
            disabled={disableOnClose}
            className={closeButtonClass}
            type="button"
            id={makeId('btnCloseModal', formatString(children), closeButtonId)}
            style={{ cursor: disableOnClose ? 'not-allowed' : 'auto' }}
          >
            <SystemIcon
              name="close"
              color={disableOnClose ? Colors.BLACK40 : Colors.BLACK100}
            />
          </button>
        )}
      </div>
    </Padder>
  );
};

export default Header;
